import { useCallback, useMemo, useState } from 'react'
import { Box, Button, Flex, Spacer, Tag, Tooltip } from '@chakra-ui/react'
import ColumnEditMenu from './ColumnEditMenu/ColumnEditMenu'
import { isNullish } from '@/utils/helper'
import FilterMenu from './FilterMenu'
import { camelToWords, isString } from '@/utils/stringHelper'
import { FiColumns } from 'react-icons/fi'
// import { RxCross2 } from 'react-icons/rx';

const TableToolbar = ({ table, displayLevel = '' }) => {
  const [modalShow, setModalShow] = useState(false)

  const { columnFilters } = table.getState()

  const columns = table.getAllLeafColumns()

  const handleClearAllFilter = () => {
    table.setColumnFilters([])
  }

  const handleDeleteFilter = (id) => {
    table.setColumnFilters((oldFilter) => oldFilter.filter((fil) => fil.id !== id))
  }

  const getColumnLabelById = useCallback(
    (columnId) => {
      const selectedColumn = table.getColumn(columnId)

      if (isNullish(selectedColumn)) {
        return columnId
      }

      return selectedColumn?.columnDef?.header({ header: { id: columnId } })
    },
    [table]
  )

  const getFilterValue = (value) => {
    if (isNullish(value)) {
      return ''
    }

    if (Array.isArray(value)) {
      return (
        <Tooltip label={value.join(', ')}>
          <Tag colorScheme="teal">{value.length > 1 ? value.length : camelToWords(value[0])}</Tag>
        </Tooltip>
      )
    }

    const match = value.match(/^type__([^ -]+)(?:--([^]+))?$/)

    if (match) {
      const filterType = match[1]
      const filterValue = match[2]

      const dateMatch = filterType.match(/^date(\w+)/)
      if (dateMatch) {
        const dateType = dateMatch[1]
        return (
          <Tag colorScheme="teal">
            {dateType} {filterValue}
          </Tag>
        )
      } else {
        return <Tag colorScheme="teal">{filterValue}</Tag>
      }
    }

    return <Tag colorScheme="teal">{value}</Tag>
  }

  const handleSaveEditColumn = (appliedColumns, availableColumns) => {
    const allColumns = new Set([...appliedColumns, ...availableColumns])

    // Create the resulting object
    const columnVisibility = {}
    let columnOrder = []

    // Populate the object with keys and boolean values
    allColumns.forEach(({ id }) => {
      columnVisibility[id] = appliedColumns.some((column) => column.id === id)
    })

    // if (columns.some((col) => col.id === 'action')) {
    //   // columnVisibility['action'] = true
    //   columnOrder = ['action', ...appliedColumns.map((column) => column.id)]
    // } else {
    //   columnOrder = appliedColumns.map((column) => column.id)
    // }
    columnOrder = appliedColumns.map((column) => column.id)

    table.setState((state) => {
      return {
        ...state,
        columnOrder: columnOrder,
        columnVisibility: columnVisibility,
      }
    })
  }
  return (
    <>
      <ColumnEditMenu
        columns={columns}
        handleSaveEditColumn={handleSaveEditColumn}
        modalShow={modalShow}
        setModalShow={setModalShow}
        displayLevel={displayLevel}
      />

      <Flex mb={3} gap="2">
        <Flex gap="3">
          {/* <FilterMenu table={table} /> */}
          <Button p="2" borderRadius={10} size="sm" onClick={handleClearAllFilter}>
            Clear all
          </Button>
          {columnFilters.map((filter) => (
            <Button
              key={filter.id}
              p="2"
              borderRadius={10}
              size="sm"
              colorScheme="teal"
              onClick={() => handleDeleteFilter(filter.id)}
            >
              <Flex gap="2" alignItems={'center'}>
                {getColumnLabelById(filter?.id)} {getFilterValue(filter?.value)}
              </Flex>
            </Button>
          ))}
        </Flex>

        {/* <ColumnFilterMenu instance={instance} /> */}
        <Spacer />
        <Button p="2" borderRadius={10} size="sm" rightIcon={<FiColumns />} onClick={() => setModalShow(true)}>
          Column
        </Button>
      </Flex>
    </>
  )
}

export default TableToolbar
